module.exports = __webpack_public_path__ + "static/fonts/PorscheNextUrduTT-Bold.2dc4bf5e.ttf";